var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("prepend"),_c('span',[_vm._v(_vm._s(_vm.$t("allBornInPeriod"))+" "+_vm._s(_vm.fromYear)+" - "+_vm._s(_vm.toYear))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }